import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Avatar = ({
  alt,
  children,
  className,
  square,
  cover,
  image,
  color,
  letter,
  theme,
  ...other
}) => {
  return (
    <div
      className={classnames(theme.avatar, {
        [theme['avatar-square']]: square,
        [theme['avatar-letter']]: letter,
      })}
      {...other}
      {...color && { style: { backgroundColor: `#${color}`, color: '#fff' } }}
    >
      <Choose>
        <When condition={children && children.length}>{children}</When>
        <Otherwise>
          <Choose>
            <When condition={cover && typeof image === 'string'}>
              <span
                aria-label={alt}
                className={theme['avatar-image']}
                style={{ backgroundImage: `url(${image})` }}
              />
            </When>
            <When condition={!cover && typeof image === 'string'}>
              <img alt={alt} className={theme['avatar-image']} src={image} />
            </When>
            <Otherwise>{image}</Otherwise>
          </Choose>
        </Otherwise>
      </Choose>
    </div>
  )
}

Avatar.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  cover: PropTypes.bool,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.bool]),
  theme: PropTypes.object,
}

Avatar.defaultProps = {
  alt: '',
  cover: false,
}

export default Avatar



// WEBPACK FOOTER //
// ./ui/Avatar/Avatar.js